import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";

const ProjectVideoSection = () => {
  return (
    <Box
      component="section"
      sx={{
        maxWidth: 1200,
        mx: "auto",
        py: 6,
        px: 2,
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Left Grid - YouTube Video */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%", // 16:9 aspect ratio
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
            }}
          >
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/wK_4B62RU8A?si=atoQMnXFo83RRk8G"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            ></iframe>
          </Box>
        </Grid>

        {/* Right Grid - Content Section */}
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                color: "#008037",
                fontWeight: 700,
                fontSize: { xs: "28px", md: "36px" },
                mb: 2,
                textTransform: "uppercase",
                letterSpacing: 1,
              }}
            >
              Experience Kalpavruksha Green
            </Typography>

            <Typography
              sx={{
                color: "#333",
                fontSize: "17px",
                lineHeight: 1.8,
                mb: 3,
                maxWidth: 500,
              }}
            >
              Dive into the vision behind our latest development —{" "}
              <strong>Kalpavruksha Green</strong>. This short video takes you
              through the serene landscapes, modern infrastructure, and
              community-focused design that define our project. Watch how we’re
              creating sustainable spaces that bring families closer to nature
              and comfort.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#008037",
                color: "#fff",
                fontWeight: 600,
                px: 4,
                py: 1.2,
                textTransform: "uppercase",
                borderRadius: 10,
                "&:hover": {
                  backgroundColor: "#006d2b",
                },
              }}
            >
              Explore Project
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectVideoSection;
